export interface AiPromptBoxSuggestionsProps {
  id: string;
}

export interface Suggestion {
  emoji: string;
  title: string;
  prompt: string;
}

export interface PromptSuggestionPills {
  suggestions: Suggestion[];
  visible: boolean;
  position: PromptSuggestionPillPosition;
  align: PromptSuggestionPillAlignment;
  maxVisibleSuggestions?: number;
  showRefreshButton?: boolean;
  recentPrompt?: string;
  refreshIcon?: string;
}

export enum PromptSuggestionPillPosition {
  ABOVE = 'above',
  BELOW = 'below',
}

export enum PromptSuggestionPillAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
